import { notification } from 'antd';
import { SESSION_ID_KEY, CLIENT_TYPES } from 'utils/signalr/messageValidators';

/**
 * Handler for ForceLogout messages
 *
 * Message structure: { operation: 'FORCELOGOUT', sessionId?: string, type: string }
 *
 * @param {Object} message - The parsed ForceLogout message
 * @param {Object} context - Handler context with { logOut, dispatch, replace }
 */
export function handleForceLogout(message, context) {
  const receivedSessionId = message.sessionId;
  const receivedClientType = message.type;
  const storedSessionId = localStorage.getItem(SESSION_ID_KEY);
  const currentClientType = CLIENT_TYPES.BROWSER; // portal-web is always browser

  // Inline fn for easy access
  const forceLogout = () => {
    notification.warning({
      message: 'Session Ended',
      description:
        'Your account has logged in elsewhere. You will now be logged out.',
      placement: 'bottomLeft',
      duration: 4,
    });
    context.logOut();
  };

  console.log('ForceLogout received', {
    receivedSessionId,
    receivedClientType,
    storedSessionId,
    currentClientType,
  });

  if (!receivedSessionId) {
    console.warn(
      'No session ID was given by the notification. Forcing logout across the board.'
    );
    return forceLogout();
  }

  if (!storedSessionId) {
    console.warn(
      'No session ID was found in local storage. Forcing logout across the board.'
    );
    return forceLogout();
  }

  if (receivedSessionId === storedSessionId) {
    console.log('Received session ID matched stored session ID. No change.');
    return;
  }
  if (!receivedClientType) {
    console.warn(
      'No target client type was given by the notification. Forcing logout across the board.'
    );
    return forceLogout();
  }

  if (receivedClientType !== currentClientType) {
    console.log(
      `Received target client type of ${receivedClientType} which does not match us (${currentClientType}). No change.`
    );
    return;
  }

  return forceLogout();
}
